import { XIN_YUE_CHANNEL, SPARK_CHANNEL } from './constant';

function HandleNoneAppClientDownload() {
  this.gameInfo = {};
  this.channel = XIN_YUE_CHANNEL;
  // 端外区分
  this.getChannel = (astName) => {
    if (astName === 'SPARK') {
      this.channel = SPARK_CHANNEL;
      return SPARK_CHANNEL;
    }
    this.channel = XIN_YUE_CHANNEL;
    return XIN_YUE_CHANNEL;
  };
  this.setGameInfo = (GameInfos) => {
    const {
      ios_download_url: iosDownloadUrl,
      android_download_url: androidDownloadUrl,
      android_cdn_channels: androidCdnChannels = {},
    } = GameInfos || {};
    const params = {
      iosurl: iosDownloadUrl,
      url: androidDownloadUrl,
    };
    // 有特定渠道
    const specialChannel = androidCdnChannels[this.channel];
    if (specialChannel && typeof specialChannel === 'object') {
      if (specialChannel.download_url) {
        params.url = specialChannel.download_url;
      }
    }

    this.gameInfo = params;
    console.log('----- HandleNoneAppClientDownload this.gameInfo =---- this.channel ', this.channel, this.gameInfo);
    return params;
  };
  this.checkDownloadState = () => ({});
  this.isAppInstalled = () => false;
  // 端外跳转到appstore
  this.doDownloadInIOS = () => window.location.href = this.gameInfo.iosurl;
  // 端外拉去apk包下载
  this.startDownload = () => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = `javascript:window.location.href='${this.gameInfo.url}'`;
    document.getElementsByTagName('body')[0].appendChild(iframe);
  };
  this.stopDownloadApp = () => ({});
  this.beforeDownloadCheck = () => '';
  this.isShowDownloadComponent = () => true;
  // 是否uo上报 暂停下载
  this.needReportDownloadPause = false;
  // 是否uo上报 完成下载
  this.needReportDownloadFinish = false;
  // 是否uo上报 安装游戏
  this.needReportInstallGame = false;
  // 是否uo上报  拉起游戏
  this.needReportlaunchGame = false;

  this.isAppVersionBiggerThan = () => true;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  this.startPreDownload = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  this.getPreDownloadProcess = async () => {};
  this.beforePreDownloadCheck  = () => '';
  console.log('-----------------------------init done HandleNoneAppClientDownload');

  return this;
}

export default HandleNoneAppClientDownload;
export { HandleNoneAppClientDownload };
